import moment from "moment-timezone";

export const formatDateInTimezone = (date, timezone, format = "short") => {
  if (!date) return "-";

  const formats = {
    short: "MM/DD/YYYY",
    medium: "MMM D, YYYY",
    long: "ddd, MMM D YYYY",
    longMonth: "MMMM D, YYYY",
    shortWithTime: "MM/DD/YYYY hh:mm A",
  };

  const formatString = formats[format] || formats.short;

  if (timezone) {
    return moment.utc(date).tz(timezone).format(formatString);
  }
  return moment.utc(date).local().format(formatString);
};

export default formatDateInTimezone;
